export default function htmlLineBreak(str) {
  return (str || '').replace(/(\r\n|\n|\r)/gm, '<br />');
}
